import { getBadgeText } from "../../../../../Banners/ProductBadge/getBadgeText";
import styles from "./index.css";
import { withTranslation } from "../../../../../translation";
import classnames from "classnames";
import PropTypes from "prop-types";

const ProductBadge = ({ className, labelledById, ...rest }) => (
  <div id={labelledById} className={classnames(styles.productBadge, className)}>
    {getBadgeText({ ...rest })}
  </div>
);

ProductBadge.propTypes = {
  className: PropTypes.string,
  labelledById: PropTypes.string
};

export default withTranslation(ProductBadge);
